import { useMutation } from '@tanstack/react-query';

import BackendService from '../services/backendService';

function useAdjustAttachmentReadability() {
  const { mutate: adjustReadability, isLoading, data, reset } = useMutation(
    BackendService.instance.adjustAttachmentReadability,
    {},
  );

  return {
    adjustReadability,
    isLoading,
    adjustedAttachment: data,
    reset,
  };
}

export default useAdjustAttachmentReadability;
